import { createExperiments } from '@cbhq/experiments';

export const workspaceExperimentConfig = {
  t0018_99ac577d: ['control', 'treatment'] as const,
  // workspace_audit_log
  t0018_aac156e2: ['control', 'treatment'] as const,
  // workspace_consensus
  t0018_7b870e9f: ['control', 'treatment'] as const,
  // workspace_settings
  t0018_3ab23203: ['control', 'treatment'] as const,
} as const;

const AppExperiments = createExperiments(workspaceExperimentConfig);

export default AppExperiments;
